// extracted by mini-css-extract-plugin
export default {"criticalAnalysisHeatMapContainer":"CriticalAnalysisHeatMap_criticalAnalysisHeatMapContainer__0YWRC"};